import { Text } from '@mantine/core';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { ZONE } from '@web/common';
import { WARNING_COLOR } from '../../../waiting-phase/NachversandBanner';
import { Part2Appointment } from '../../../versand/utils';

// The date sits in the title so the collapsed card still says when the call is; the time only on
// the day itself.
export const NachversandHomeBannerTitle = ({
  appointment,
  missed,
}: {
  appointment: Part2Appointment;
  missed: boolean;
}) => {
  const { t, i18n } = useTranslation('versand');

  if (missed) {
    return (
      <Text fw={700} size="16px" c={WARNING_COLOR}>
        {t('Missed.HomeTitle')}
      </Text>
    );
  }

  const callStart = DateTime.fromJSDate(appointment.startTime, {
    zone: ZONE,
  }).setLocale(i18n.language);
  const isToday = callStart.hasSame(DateTime.now().setZone(ZONE), 'day');

  return (
    <Text fw={700} size="16px" c="#202020">
      {isToday
        ? t('Booked.HomeTitleToday', { time: callStart.toFormat('HH:mm') })
        : t('Booked.HomeTitle', {
            date: callStart.toLocaleString({ day: 'numeric', month: 'long' }),
          })}
    </Text>
  );
};
